import React from 'react';
import { NewMacroSC } from './NewMacro.style';
import NewMacroStep1 from './new-macro-step-1/NewMacroStep1';
import NewMacroStep2 from './new-macro-step-2/NewMacroStep2';
import NewMacroStep3 from './new-macro-step-3/NewMacroStep3';
import NewMacroStep5 from './new-macro-step-5/NewMacroStep5';
import NewMacroStep4 from './new-macro-step-4/NewMacroStep4';

const NewMacro = ({ formikProp, ticketDepartment, ticketDepName, loadingCreateMacro, editor }) => {
  return (
    <NewMacroSC>
      <NewMacroStep1 formikProp={formikProp} />
      <NewMacroStep2 formikProp={formikProp} ticketDepartment={ticketDepartment} ticketDepName={ticketDepName} />
      <NewMacroStep3 formikProp={formikProp} />
      <NewMacroStep4 formikProp={formikProp} />
      <NewMacroStep5 formikProp={formikProp} loadingCreateMacro={loadingCreateMacro} editor={editor} />
    </NewMacroSC>
  );
};
export default NewMacro;
